import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=42180825&scoped=true&"
import script from "./CustomIcon.vue?vue&type=script&lang=js&"
export * from "./CustomIcon.vue?vue&type=script&lang=js&"
import style0 from "./CustomIcon.vue?vue&type=style&index=0&id=42180825&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42180825",
  null
  
)

export default component.exports